import {z} from '@hono/zod-openapi';

import {InventoryValueCardSchema} from './InventoryValueCardSchema';
import {InventoryValueMonthSchema} from './InventoryValueMonthSchema';

export const InventoryValueResponseSchema = z
  .object({
    asOf: z.string(),
    capturedAt: z.string(),
    timezone: z.string(),
    currentPriceDate: z.string(),
    historicalAgingAvailable: z.boolean(),
    cards: z.array(InventoryValueCardSchema),
    history: z.array(InventoryValueMonthSchema),
    warehouses: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        branchId: z.string().nullable(),
        branchName: z.string().nullable(),
      })
    ),
  })
  .openapi('InventoryValueResponse');

export type InventoryValueResponse = z.infer<typeof InventoryValueResponseSchema>;
